import { render, staticRenderFns } from "./ShBottom.vue?vue&type=template&id=73042b8a&scoped=true&"
import script from "./ShBottom.vue?vue&type=script&lang=js&"
export * from "./ShBottom.vue?vue&type=script&lang=js&"
import style0 from "./ShBottom.vue?vue&type=style&index=0&id=73042b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73042b8a",
  null
  
)

export default component.exports